import { render, staticRenderFns } from "./toWordMixin.js.vue?vue&type=template&id=34ff2b4d&"
import script from "./toWordMixin.js.vue?vue&type=script&lang=js&"
export * from "./toWordMixin.js.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports